import React from "react"
import { createRoot } from 'react-dom/client';
import "./index.css"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import { Provider } from "react-redux"
import store from "./store"

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<Provider store={store} ><App /></Provider>)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register()
// serviceWorkerRegistration.register();
